import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["icon", "text"];
  static values = {
    source: String,
    successContent: String,
    initialContent: String,
  };

  copy() {
    navigator.clipboard.writeText(this.sourceValue).then(() => {
      // Update content to show success state
      this.iconTarget.className = "fa fa-check";
      this.textTarget.innerHTML = this.successContentValue;

      // Reset after 3 seconds
      setTimeout(() => {
        this.iconTarget.className = "fa fa-copy";
        this.textTarget.innerHTML = this.initialContentValue;
      }, 3000);
    });
  }
}
